import styled from 'styled-components';
import { Form } from '@unform/web';

export const Container = styled.div`
  flex: 1;
  display: flex;
`;

export const Content = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  // margin-top: 3.42rem;
  // margin-left: 4.4rem;
	padding: 3.9rem 1.5rem 5rem 5.5rem; // 4.42rem 1.5rem 5rem 5.5rem;
  // padding: 1rem 1.5rem;
  // border: 2px solid red;

  // 767px
  @media (max-width: 47.9375rem) {
    margin-left: 0;
		padding: 4.3rem 0.5rem 5rem;
  }
	// 479px
  @media (max-width: 29.9375rem) {
		padding: 4.3rem 0.6rem 5rem;
	}
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 20px;
	// border: 2px solid blue;

  div {
    display: flex;
    flex-direction: column;
    margin-right: 50px;

    h1 {
      font-size: 24px;
      font-weight: 500;
			text-overflow: ellipsis;
    }
    h2 {
      font-size: 20px;
      color: #607d8b;
			text-overflow: ellipsis;
    }
  }

	// 479px
  @media (max-width: 29.9375rem) {
		margin-bottom: 10px;

		div {
			margin-right: 0px;

			h1 {
				font-size: 18px;
			}
			h2 {
				font-size: 16px;
			}
		};
		button {
			padding: 0 15px !important;
			font-size: 14px;
		}
	}
`;

export const Filtros = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 10px;
  padding: 10px 20px;
  box-shadow: 0 1px 8px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
	// border: 2px solid red;

	// 720px
  @media (max-width: 45rem) {
		width: 100%;
	};
	// 479px
  @media (max-width: 29.9375rem) {
		margin: 0px;
  	padding: 10px 10px;
		width: 100%;
	}
`;

export const FormView = styled(Form)`
  display: flex;
  align-items: center;
	// border: 2px solid blue;

	.input-content {
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		width: 100%;
		margin-right: 10px;

		:last-child {
			margin-right: 0;
		}

		span {
			font-size: 1rem;
			font-weight: 500;
			color: #455a64;
		}
	}

	button {
		display: flex;
		background-color: #1a83ff;
		color: #fff;
		font-weight: 600;
		border-radius: 8px;
		padding: 9px 30px;

		svg {
			font-size: 20px;
			margin-right: 10px;
		}
	}

	// 720px
  @media (max-width: 45rem) {
    flex-direction: column;
		width: 100%;

		.input-content {
			width: 100%;
		};
		.input-content-button {
			width: 100%;
		};
  }
	// 479px
  @media (max-width: 29.9375rem) {
		flex-direction: column;
		width: 100%;

		.input-content {
			width: 100%;

			div {
				padding: 2px 5px !important;
			}
		};
		.input-content-button {
			margin-top: 19px;
			width: 100%;

			span {
				visibility: hidden;
				display: none;
			};

			button {
				font-size: 14px;
				padding: 5px 20px;
			}
		};
	}
`;

export const CupomList = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 20px;
  list-style: none;
  margin: 20px 20px 0 0;
	// border: 2px solid red;
	
// 1140px
  @media (max-width: 71.25rem) {
    grid-template-columns: repeat(1, 1fr);
		grid-gap: 20px;
  }
	// 479px
  @media (max-width: 29.9375rem) {
		grid-template-columns: repeat(1, 1fr);
		grid-gap: 20px;
		width: 100%;
  	margin: 20px 0 0 0;
	}
`;

export const CupomItem = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  border-radius: 7px;
  box-shadow: 0 1px 8px rgba(0, 0, 0, 0.2);

  .cupom-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 20px 10px;

    .menu-button {
      border: 0;

      > svg {
        font-size: 25px;
        padding: 0;
        margin-right: 0;
      }
    }
    .menu-list {
      display: flex;
      flex-direction: column;
      justify-content: center;
      padding: 0 0;
      border-radius: 8px;

      .item {
        padding: 10px 10px 10px 20px;
        border-bottom: 1px solid #cbd5e0;

        :first-child {
          border-top-left-radius: 8px;
          border-top-right-radius: 8px;
        }
        :last-child {
          border-bottom: 0;
          border-bottom-left-radius: 8px;
          border-bottom-right-radius: 8px;
        }
      }
    }

    div {
      display: flex;
      align-items: center;

      svg {
        font-size: 24px;
        margin-right: 10px;
      }

      span {
        font-size: 20px;
      }
    }
  }
  .cupom-rules {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 30px 20px 20px;
    width: 100%;
    // border: 2px solid red;

    .rules {
      display: flex;
      flex-direction: column;
      width: 100%;
      padding-right: 50px;
      // border: 2px solid green;

      p {
        font-size: 16px;
        color: #455a64;
        white-space: nowrap;
      }
    }

    .dados {
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      width: 100%;
      // border: 2px solid black;

      p {
        font-size: 14px;
        color: #455a64;
        white-space: nowrap;

        span {
          color: #333;
        }
      }
    }
  }
  .cupom-dates {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 20px 10px;

    div {
      display: flex;
      flex-direction: column;
      justify-content: center;

      button {
        background-color: transparent;
        border: none;
        font-size: 14px;
        font-weight: 600;
        color: #2196f3;
      }

      span.label {
        font-size: 13px;
        color: #607d8b;
      }
      span {
        font-size: 14px;
        color: #37474f;
      }
    }
    div.fim {
      align-items: flex-end;
    }
  }

	// 479px
  @media (max-width: 29.9375rem) {
		width: 100%;

		.cupom-title {
			padding: 10px 10px 0px;

			 div {
				svg {
					font-size: 24px;
					margin-right: 10px;
				}

				span {
					font-size: 20px;
				}
			}
		};
		.cupom-rules {
			flex-direction: column;
			justify-content: center;
			padding: 10px 5px 10px 10px;
			width: 100%;

			.rules {
				width: 100%;
				padding-right: 0px;

				p {
					font-size: 15px;
				}
			}

			.dados {
				align-items: flex-start;
				width: 100%;
				// border: 2px solid black;

				p {
					font-size: 14px;
				}
			}
		};
		.cupom-dates {
			padding: 0 10px 10px;

			div {
				span.label {
					font-size: 13px;
				}
				span {
					font-size: 14px;
				}
			}
			div.fim {
				align-items: flex-end;
			}
		}
	}
`;

export const NenhumCupom = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  svg {
    font-size: 150px;
    margin: 50px 0 30px 0;
  }
  h1 {
    font-size: 20px;
    font-weight: 500;
  }
  h2 {
    font-size: 18px;
    margin-bottom: 20px;
  }
`;
